import { NodeId } from 'web';
import type { ImageRef } from '@/types/api/assets';
import type { FlowGraph } from '../FlowGraph';

export class PreviewView {
  constructor(
    private graph: FlowGraph,
    private id: NodeId,
  ) {}

  evaluateImageInputPoster(): ImageRef | undefined {
    const evaluatedFile = this.graph.evaluateInput(this.id, 'file');
    if (evaluatedFile?.type !== 'image') {
      return undefined;
    }

    if (evaluatedFile.value.type === 'file') {
      return { url: evaluatedFile.value.url, key: evaluatedFile.value.blobstore?.id };
    }

    // Handle computed images by rendering them
    const computedImage = this.graph.wasm.call((wasm) => wasm.exportNodeRender(this.id));
    return computedImage ? { url: computedImage.data } : undefined;
  }
}
